import { CKSkeleton } from 'clearkit';
import moment from 'moment';
import { useState } from 'react';

import { useActiveIntegrationsQuery } from '~/generated/graphql';

import ActiveIntegrationCard from './ActiveIntegrationCard';
import ActiveIntegrationsTimeRangeFilters from './ActiveIntegrationsTimeRangeFilters';

function ActiveIntegrationsList() {
  // Set as last 7 days window by default
  const [queryStartDate, setQueryStartDate] = useState<moment.Moment>(
    moment().add(-7, 'day'),
  );
  const {
    data: { accountConnectors } = {},
    loading: loading,
  } = useActiveIntegrationsQuery({
    fetchPolicy: 'no-cache',
  });
  return (
    <div className="px-10 py-6 grid gap-4">
      <CKSkeleton
        className="h-10 rounded w-96"
        isLoading={loading}
        label="loading"
      >
        <ActiveIntegrationsTimeRangeFilters
          queryStartDate={queryStartDate}
          setQueryStartDate={setQueryStartDate}
        />
      </CKSkeleton>
      <CKSkeleton className="h-5 w-[20ch]" isLoading={loading} label="loading">
        <h3 className="text-base font-medium">Active Integrations</h3>
      </CKSkeleton>
      <CKSkeleton
        className="w-full h-40 rounded"
        isLoading={loading}
        label="loading"
      >
        {accountConnectors?.map((accountConnector) => (
          <ActiveIntegrationCard
            accountConnector={accountConnector}
            key={accountConnector.id}
            queryStartDate={queryStartDate}
          />
        ))}
      </CKSkeleton>
    </div>
  );
}

export default ActiveIntegrationsList;
